export * from './FilterTags';
export * from './IFilterModel';
export * from './filter.model.service';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/filterModel/index.ts